var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcWhatsApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logos:whatsapp-icon",
    clipPath: "url(#clip0_2567_16773)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.933437 16.3071C0.932687 19.0168 1.64069 21.6625 2.98694 23.9945L0.804688 31.9623L8.95869 29.8243C11.214 31.052 13.7409 31.6954 16.3087 31.6955H16.3154C24.7923 31.6955 31.6927 24.7976 31.6963 16.3193C31.6979 12.2109 30.0994 8.34764 27.1952 5.44114C24.2914 2.53489 20.4296 0.933516 16.3148 0.931641C7.83694 0.931641 0.937063 7.82914 0.933563 16.3071",
    fill: "url(#paint0_linear_2567_16773)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M0.38375 16.302C0.382875 19.1091 1.11625 21.8495 2.5105 24.265L0.25 32.5184L8.69637 30.3037C11.0236 31.5726 13.6439 32.2416 16.3101 32.2426H16.317C25.098 32.2426 32.2463 25.0966 32.25 16.3147C32.2515 12.0588 30.5955 8.05662 27.5875 5.046C24.5791 2.03575 20.5791 0.37675 16.317 0.375C7.5345 0.375 0.38725 7.52 0.38375 16.302ZM5.41375 23.849L5.09837 23.3484C3.77262 21.2404 3.07288 18.8044 3.07387 16.303C3.07675 9.00363 9.01725 3.065 16.322 3.065C19.8595 3.0665 23.184 4.4455 25.6845 6.9475C28.1849 9.44975 29.5608 12.776 29.5599 16.3138C29.5566 23.6131 23.616 29.5525 16.317 29.5525H16.3118C13.9351 29.5513 11.6042 28.913 9.5715 27.7069L9.08775 27.42L4.0755 28.7341L5.41375 23.8489V23.849Z",
    fill: "url(#paint1_linear_2567_16773)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.3325 9.64343C12.0343 8.98055 11.7204 8.96718 11.4367 8.95555C11.2045 8.94555 10.939 8.9463 10.6737 8.9463C10.4082 8.9463 9.97687 9.04618 9.61225 9.4443C9.24725 9.8428 8.21875 10.8058 8.21875 12.7644C8.21875 14.7232 9.64538 16.6161 9.84425 16.8819C10.0434 17.1473 12.5984 21.2953 16.6449 22.8911C20.0079 24.2172 20.6923 23.9534 21.4221 23.8869C22.1521 23.8207 23.7776 22.9242 24.1092 21.9946C24.4411 21.0651 24.4411 20.2683 24.3416 20.1018C24.2421 19.9359 23.9766 19.8363 23.5785 19.6373C23.1802 19.4382 21.223 18.4751 20.8581 18.3422C20.4931 18.2094 20.2277 18.1432 19.9622 18.5418C19.6967 18.9398 18.9344 19.8363 18.702 20.1018C18.4699 20.3679 18.2375 20.4011 17.8395 20.2019C17.4411 20.0022 16.159 19.5823 14.6379 18.2262C13.4544 17.1709 12.6554 15.8678 12.4231 15.4692C12.1909 15.0712 12.3983 14.8554 12.5979 14.6571C12.7768 14.4787 12.9961 14.1922 13.1954 13.9598C13.3939 13.7273 13.4601 13.5614 13.5929 13.2959C13.7257 13.0302 13.6592 12.7977 13.5599 12.5986C13.4601 12.3994 12.6865 10.4306 12.3325 9.64343Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2567_16773",
    x1: 1545.39,
    y1: 3103.99,
    x2: 1545.39,
    y2: 0.931641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2567_16773",
    x1: 1600.25,
    y1: 3214.71,
    x2: 1600.25,
    y2: 0.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2567_16773"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32.25,
    fill: "white",
    transform: "translate(0.25 0.375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWhatsApp);
export default __webpack_public_path__ + "static/media/Ic_WhatsApp.40d917274e79dbbc757c8bd504ac2306.svg";
export { ForwardRef as ReactComponent };